import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ToasterService } from 'angular2-toaster';
import { AppService, CoreProxyService, CoreTypes } from 'common-cloudstudio';
import { IncidentsComponent } from '../incidents/incidents.component';
import { IncidentService } from '../../services/incident.service';

@Component({
  selector: 'app-associate-incidents',
  templateUrl: './associate-incidents.component.html',
  styleUrls: ['./associate-incidents.component.scss'], 
})
export class AssociateIncidentsComponent implements OnInit {
  @ViewChild('incidents') public _incidents: IncidentsComponent;
  selectedIncident: CoreTypes.Incident = null;
  @Input() communicationIDs: number[] = []; 

  @Output() disableForm = new EventEmitter<any>();
  @Output() onCloseForm = new EventEmitter<any>();
  _formStatus: number = 0;
  _errorBackEnd: string = '';
  _params: any[] = [
    {
      "AllowedValues": null,
      "Hidden": false,
      "Mandatory": true,
      "MultiSelectLiterals": null,
      "ParameterID": 3,
      "ParameterType": 1,
      "Prompt": "ID Evento",
      "RefreshOnChange": false,
      "UniqueParameterID": null,
      "ValueCheck": false,
      "ValueDateEnd": null,
      "ValueDateEndExpression": null,
      "ValueDateStart": null,
      "ValueDateStartExpression": null,
      "ValueMultiString": null,
      "ValueNumber": '',
      "ValueString": null
    },
    {
      "AllowedValues": null,
      "Hidden": false,
      "Mandatory": true,
      "MultiSelectLiterals": null,
      "ParameterID": 1,
      "ParameterType": 9,
      "Prompt": "Período",
      "RefreshOnChange": false,
      "UniqueParameterID": null,
      "ValueCheck": false,
      "ValueDateEnd": {
        "Date": {
          "Day": 12,
          "Month": 7,
          "Year": 2024
        },
        "Time": {
          "Hour": 22,
          "Millisecond": 0,
          "Minute": 33,
          "Second": 22
        }
      },
      "ValueDateEndExpression": "",
      "ValueDateStart": {
        "Date": {
          "Day": 11,
          "Month": 7,
          "Year": 2024
        },
        "Time": {
          "Hour": 0,
          "Millisecond": 0,
          "Minute": 0,
          "Second": 0
        }
      },
      "ValueDateStartExpression": "",
      "ValueMultiString": null,
      "ValueNumber": 0,
      "ValueString": null
    },
    {
      "AllowedValues": [
        {
          "Name": "Todos los eventos",
          "Value": "556"
        },
        {
          "Name": "Accidente",
          "Value": "560"
        },
        {
          "Name": "Asistencia",
          "Value": "560"
        }
      ],
      "Hidden": false,
      "Mandatory": true,
      "MultiSelectLiterals": null,
      "ParameterID": 9999,
      "ParameterType": 2,
      "Prompt": "Tipo Evento",
      "RefreshOnChange": true,
      "UniqueParameterID": null,
      "ValueCheck": false,
      "ValueDateEnd": null,
      "ValueDateEndExpression": null,
      "ValueDateStart": null,
      "ValueDateStartExpression": null,
      "ValueMultiString": null,
      "ValueNumber": 0,
      "ValueString": "556"
    }
  ]

  constructor(
    private _appService: AppService,
    private _toasterService: ToasterService,
    private coreProxyService: CoreProxyService,
    private incidentService: IncidentService
  ) {}

  ngOnInit(): void {
    if(!this.selectedIncident) this.disableForm.emit(true);
  }

  onSelectedIncident(event) {
    this.selectedIncident = event;
    if(this.selectedIncident) this.disableForm.emit(false);
  }

  cleanSelectedIncident() {
    this._incidents.onCleanSelectedRow();
  }

  onSave() {
    this._formStatus = 1;
    if(!this.selectedIncident?.IncidentID || !this.communicationIDs?.length) return;
    this.incidentService.attachCommunicationsToIncident(this.selectedIncident?.IncidentID, this.communicationIDs).then(data => {
      setTimeout(() => {
        this._formStatus = 0;
        this.onCloseForm.emit(true);
        this.incidentService.onRefreshCommunicationList.next(true);
        this._toasterService.pop('success', null, 'Se realizó correctamente la asociación al evento: ' + ' #' + this.selectedIncident?.IncidentID);
        this.cleanSelectedIncident();
      }, 200);
    }).catch(err =>{
      this._errorBackEnd = err.Message;
      this._appService.showException(err);
      this._formStatus = 2;
    })
  }
}


